import React from 'react';
import { FileText, Image, Video, File, Upload, Search, FolderOpen } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * 파일관리 모듈 사이드바 (LeftMenu에서 activeModule === 'files' 일 때 표시)
 * 파일 카테고리 (ProfilePart + 워크스페이스는 LeftMenuHeader로 분리됨)
 */

const FILE_CATEGORIES = [
  { name: '전체 파일', icon: FolderOpen, count: 0, active: true },
  { name: '문서', icon: FileText, count: 0 },
  { name: '이미지', icon: Image, count: 0 },
  { name: '동영상', icon: Video, count: 0 },
  { name: '기타', icon: File, count: 0 },
];

const LeftMenuFiles: React.FC = () => {
  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-y-auto px-4 pt-3">
        {/* 검색 */}
        <div className="flex items-center gap-2 px-2 py-1.5 rounded-lg bg-muted mb-3 cursor-pointer hover:bg-muted/80 transition-colors">
          <Search className="size-4 text-muted-foreground" />
          <span className="text-sm text-muted-foreground">파일 검색...</span>
        </div>

        {/* 업로드 버튼 */}
        <button className="w-full flex items-center gap-2 px-2 py-2 rounded-lg text-sm font-medium text-primary hover:bg-primary/5 cursor-pointer transition-colors mb-2">
          <Upload className="size-4" />
          <span>파일 업로드</span>
        </button>

        {/* 파일 카테고리 */}
        <div className="space-y-0.5">
          {FILE_CATEGORIES.map((cat) => {
            const Icon = cat.icon;
            return (
              <button
                key={cat.name}
                className={cn(
                  'w-full flex items-center gap-2.5 px-2 py-2 rounded-lg text-sm transition-colors cursor-pointer',
                  cat.active
                    ? 'bg-muted text-foreground font-medium'
                    : 'text-muted-foreground hover:bg-muted/50 hover:text-foreground'
                )}
              >
                <Icon className="size-4 shrink-0" />
                <span className="truncate">{cat.name}</span>
                {cat.count > 0 && (
                  <span className="ml-auto text-xs text-muted-foreground">{cat.count}</span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LeftMenuFiles;
